(function() {
    'use strict';

    angular
        .module('functional7App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('licencia', {
            parent: 'entity',
            url: '/licencia',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'functional7App.licencia.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/licencia/licencias.html',
                    controller: 'LicenciaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('licencia');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('licencia-detail', {
            parent: 'licencia',
            url: '/licencia/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'functional7App.licencia.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/licencia/licencia-detail.html',
                    controller: 'LicenciaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('licencia');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Licencia', function($stateParams, Licencia) {
                    return Licencia.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'licencia',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('licencia-detail.edit', {
            parent: 'licencia-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/licencia/licencia-dialog.html',
                    controller: 'LicenciaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Licencia', function(Licencia) {
                            return Licencia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('licencia.new', {
            parent: 'licencia',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/licencia/licencia-dialog.html',
                    controller: 'LicenciaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fechaAlta: null,
                                fechaCaducidad: null,
                                precio: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('licencia', null, { reload: 'licencia' });
                }, function() {
                    $state.go('licencia');
                });
            }]
        })
        .state('licencia.edit', {
            parent: 'licencia',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/licencia/licencia-dialog.html',
                    controller: 'LicenciaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Licencia', function(Licencia) {
                            return Licencia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('licencia', null, { reload: 'licencia' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('licencia.delete', {
            parent: 'licencia',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/licencia/licencia-delete-dialog.html',
                    controller: 'LicenciaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Licencia', function(Licencia) {
                            return Licencia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('licencia', null, { reload: 'licencia' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
